import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import { Button } from '@ui-library/button';
import useStores from '@stores/useStores';
import { FeatureFlagKeys } from '@lib/experiment';
import { useFeatureFlagObserver } from '@hooks/useFeatureFlagObserver';

import CredentialPopup from './credential-popup';
import SourceSettingsRow from '../../source-settings-row';

export const ExtractSourceAccountManagement: React.FC = observer(() => {
  const { sourceDataStore, userStore, permissionsStore } = useStores();
  const [showCredentialPopup, setShowCredentialPopup] = useState(false);
  const [username, setUsername] = useState('');

  const getCredentialInfo = useCallback(async () => {
    const { accountInfo } = await sourceDataStore.getCredentialInfo(true);
    setUsername(accountInfo?.name || '');
  }, [setUsername]);

  useEffect(() => {
    getCredentialInfo();
  }, [sourceDataStore.config, getCredentialInfo]);

  const isNewPermissionModelEnforcementEnabled = useFeatureFlagObserver(
    FeatureFlagKeys.enableNewPermissionsModelEnforcement,
  );

  const editButtonState = (() => {
    const canEditSourceAccount = isNewPermissionModelEnforcementEnabled
      ? userStore.isOrgAdmin
      : permissionsStore.hasPermission({
          resourceType: 'source',
          action: 'edit',
          resourceId: sourceDataStore.id ?? '',
        });

    return {
      disabled: !canEditSourceAccount,
      disabledReason: !canEditSourceAccount
        ? 'You do not have permission to edit credentials.'
        : '',
    };
  })();

  const description = `You are currently connected to ${sourceDataStore.sourceDef.name} account ${username}`;
  let modal = null;
  if (showCredentialPopup) {
    modal = <CredentialPopup onCancel={() => setShowCredentialPopup(false)} />;
  }
  return (
    <>
      {modal}
      <SourceSettingsRow
        name="Credentials"
        description={description}
        cta={
          <Button
            type="default"
            onClick={() => setShowCredentialPopup(true)}
            name="Edit Credentials"
            disabled={editButtonState.disabled}
            tooltip={{
              title: editButtonState.disabledReason,
              show: editButtonState.disabled,
            }}
          />
        }
      />
    </>
  );
});
